import { PropType, VNode, VueConstructor, defineComponent } from 'vue'
import { INotificationItem } from '../NotificationItemBase'
import { VCard, VCardText, VIcon } from 'vuetify/lib'
import { PropostaHelper } from '@/utils/PropostaHelper'
import { PROPOSTA_SITUACOES, PROPOSTA_STATUS } from '@/types'
import { CaptureEvent, Events } from '@/services/AmplitudeService'

interface MetadataEntidadeLog {
	Status: PROPOSTA_STATUS
	Situacao: PROPOSTA_SITUACOES
}

interface Metadata {
	De: string
	Para: string
	Author: string
}

export const NotificationProposalStatusChange = defineComponent({
	name: 'NotificationProposalStatusChange',
	props: {
		notification: { type: Object as PropType<INotificationItem>, required: true }
	},

	computed: {
		metadata(): Metadata {
			return JSON.parse(this.notification.metadata) as Metadata
		},

		oldValue(): MetadataEntidadeLog {
			return JSON.parse(this.metadata.De) as MetadataEntidadeLog
		},

		newValue(): MetadataEntidadeLog {
			return JSON.parse(this.metadata.Para) as MetadataEntidadeLog
		},

		statusChangedText(): VNode {
			if (this.oldValue.Status == this.newValue.Status) return <div>Status {PropostaHelper.getStatusDescricao(this.oldValue.Status)}</div>

			return (
				<div>
					Status {PropostaHelper.getStatusDescricao(this.oldValue.Status)} <VIcon size="16">arrow_forward</VIcon>{' '}
					{PropostaHelper.getStatusDescricao(this.newValue.Status)}
				</div>
			)
		},

		situationChangedText(): VNode {
			if (this.oldValue.Situacao == this.newValue.Situacao)
				return <div>Situação {PropostaHelper.getSituacaoDescricao(this.oldValue.Situacao)}</div>

			return (
				<div>
					{this.metadata.Author} alterou a situação de <b>{PropostaHelper.getSituacaoDescricao(this.oldValue.Situacao)}</b> para{' '}
					<b>{PropostaHelper.getSituacaoDescricao(this.newValue.Situacao)}</b>
				</div>
			)
		}
	},

	methods: {
		clickNotification() {
			this.$emit('notification:clicked', this.notification.id)
			CaptureEvent(Events.NotificationClickedProposalStatus)
		}
	},

	render() {
		return (
			<VCard elevation="0" outlined>
				<VCardText onClick={this.clickNotification}>
					{/* {this.statusChangedText} */}
					{this.situationChangedText}
				</VCardText>
			</VCard>
		)
	}
}) as unknown as VueConstructor

export default NotificationProposalStatusChange
